import { inject, watch, type Ref } from 'vue'
import { SIDEBAR_FLYOUT_HOLD_OPEN } from './const'

/** Suspends the enclosing collapsed `DSSidebarGroup` flyout's hover auto-close while `isOpen` is true. */
export function useFlyoutHoldOpen(isOpen: Ref<boolean | undefined>) {
  const holdFlyoutOpen = inject(SIDEBAR_FLYOUT_HOLD_OPEN, undefined)
  if (!holdFlyoutOpen) return

  let release: (() => void) | undefined

  watch(isOpen, open => {
    if (open) {
      release = holdFlyoutOpen()
    } else {
      release?.()
      release = undefined
    }
  })
}
